var map_cfg = {
 "mapWidth": "100%",
 "mapHeight": 410,
 "shadowAllow": false,
 "shadowWidth": 2,
 "shadowOpacity": 0.2,
 "shadowColor": "black",
 "shadowX": 0,
 "shadowY": 0,
 "iPhoneLink": true,
 "isNewWindow": false,
 "zoomEnable": true,
 "zoomEnableControls": true,
 "zoomIgnoreMouseScroll": true,
 "zoomMax": 8,
 "zoomStep": 0.4,
 "borderColor": "#ffffff",
 "borderColorOver": "#ffffff",
 "borderOpacity": 0.5,
 "nameColor": "#ffffff",

"nameFontFamily": 'MyriadPro-SemiCn-5',

 "nameColorOver": "#ffffff",
 "nameFontSize": "12px",
 "nameFontWeight": "normal",
 "nameStroke": false,
 "nameStrokeColor": "#4C4339",
 "nameStrokeColorOver": "#4C4339",
 "nameStrokeWidth": 1.5,
 "nameStrokeOpacity": 0.5,
 "overDelay": 300,
 "nameAutoSize": false,
 "tooltipOnHighlightIn": false,
 "freezeTooltipOnClick": false,
 "mapId": "vcg",
 "map_data": {
  "st1": {
   "link": "",
   "name": "Alabama",
   "color": "#4c4339",
   "comment": "<h3><strong>Aleissia Cano</strong></h3><p>Specifications Sales Rep</p><p>aleissia@polilam.com</p><p>409.218.2447</p>",
   "colorOver": "#945751",
   "shortname": "AL"

  },
  "st2": {
   "link": "",
   "name": "Alaska",
   "color": "#4c4339",
   "comment": "<h3><strong>Aleissia Cano</strong></h3><p>Specifications Sales Rep</p><p>aleissia@polilam.com</p><p>409.218.2447</p>",
   "colorOver": "#945751",
   "shortname": "AK"
  },
  "st3": {
   "link": "",
   "name": "Arizona",
   "color": "#4c4339",
   "comment": "<h3><strong>Sandra Todd</strong></h3><p>Specifications Sales Rep</p><p>sandra@polilam.com</p><p>562.717.2722</p>",
   "colorOver": "#945751",
   "shortname": "AZ"
  },
  "st4": {
   "link": "",
   "name": "Arkansas",
   "color": "#4c4339",
   "comment": "<h3><strong>Aleissia Cano</strong></h3><p>Specifications Sales Rep</p><p>aleissia@polilam.com</p><p>409.218.2447</p>",
   "colorOver": "#945751",
   "shortname": "AR"
  },
  "st5": {
   "link": "",
   "name": "California",
   "color": "#4c4339",
   "comment": "<h3><strong>CPS Garten Corporation</strong></h3><p>info@cpsgarten.com</p><p>949.455.1600</p><br><h3><strong>Sandra Todd</strong></h3><p>Specifications Sales Rep</p><p>sandra@polilam.com</p><p>562.717.2722</p>",
   "colorOver": "#945751",
   "shortname": "CA"
  },
  "st6": {
   "link": "",
   "name": "Colorado",
   "color": "#4c4339",
   "comment": "<h3><strong>Aleissia Cano</strong></h3><p>Specifications Sales Rep</p><p>aleissia@polilam.com</p><p>409.218.2447</p>",
   "colorOver": "#945751",
   "shortname": "CO"
  },
  "st7": {
   "link": "",
   "name": "Connecticut",
   "color": "#4c4339",
   "comment": "<h3><strong>Laurie Barton</strong></h3><p>Specifications Sales Rep</p><p>laurie@polilam.com</p><p>781.217.1471</p>",
   "colorOver": "#945751",
   "shortname": "CT"
  },
  "st8": {
   "link": "",
   "name": "Delaware",
   "color": "#4c4339",
   "comment": "<h3><strong>Joey Mortel</strong></h3><p>Specifications Sales Rep</p><p>joey@polilam.com</p><p>646.248.0611</p>",
   "colorOver": "#945751",
   "shortname": "DE"
  },
  "st9": {
   "link": "",
   "name": "District of Columbia",
   "color": "#4c4339",
   "comment": "<h3><strong>Joey Mortel</strong></h3><p>Specifications Sales Rep</p><p>joey@polilam.com</p><p>646.248.0611</p>",
   "colorOver": "#945751",
   "shortname": "DC"
  },
  "st10": {
   "link": "",
   "name": "Florida",
   "color": "#4c4339",
   "comment": "<h3><strong>Aleissia Cano</strong></h3><p>Specifications Sales Rep</p><p>aleissia@polilam.com</p><p>409.218.2447</p>",
   "colorOver": "#945751",
   "shortname": "FL"
  },
  "st11": {
   "link": "",
   "name": "Georgia",
   "color": "#4c4339",
   "comment": "<h3><strong>Aleissia Cano</strong></h3><p>Specifications Sales Rep</p><p>aleissia@polilam.com</p><p>409.218.2447</p>",
   "colorOver": "#945751",
   "shortname": "GA"
  },
  "st12": {
   "link": "",
   "name": "Hawaii",
   "color": "#4c4339",
   "comment": "<h3><strong>Aleissia Cano</strong></h3><p>Specifications Sales Rep</p><p>aleissia@polilam.com</p><p>409.218.2447</p>",
   "colorOver": "#945751",
   "shortname": "HI"
  },
  "st13": {
   "link": "",
   "name": "Idaho",
   "color": "#4c4339",
   "comment": "<h3><strong>Aleissia Cano</strong></h3><p>Specifications Sales Rep</p><p>aleissia@polilam.com</p><p>409.218.2447</p>",
   "colorOver": "#945751",
   "shortname": "ID"
  },
  "st14": {
   "link": "",
   "name": "Illinois",
   "color": "#4c4339",
   "comment": "<h3><strong>Midwest Sales</strong></h3><p>midwest@polilam.com</p><p>409.218.2447</p>",
   "colorOver": "#945751",
   "shortname": "IL"
  },
  "st15": {
   "link": "",
   "name": "Indiana",
   "color": "#4c4339",
   "comment": "<h3><strong>Midwest Sales</strong></h3><p>midwest@polilam.com</p><p>409.218.2447</p>",
   "colorOver": "#945751",
   "shortname": "IN"
  },
  "st16": {
   "link": "",
   "name": "Iowa",
   "color": "#4c4339",
   "comment": "<h3><strong>Krista Holen</strong></h3><p>Specifications Sales Rep</p><p>krista@polilam.com</p><p>952.426.5066</p>",
   "colorOver": "#945751",
   "shortname": "IA"
  },
  "st17": {
   "link": "",
   "name": "Kansas",
   "color": "#4c4339",
   "comment": "<h3><strong>Midwest Sales</strong></h3><p>midwest@polilam.com</p><p>409.218.2447</p>",
   "colorOver": "#945751",
   "shortname": "KS"
  },
  "st18": {
   "link": "",
   "name": "Kentucky",
   "color": "#4c4339",
   "comment": "<h3><strong>Midwest Sales</strong></h3><p>midwest@polilam.com</p><p>409.218.2447</p>",
   "colorOver": "#945751",
   "shortname": "KY"
  },
  "st19": {
   "link": "",
   "name": "Louisiana",
   "color": "#4c4339",
   "comment": "<h3><strong>Aleissia Cano</strong></h3><p>Specifications Sales Rep</p><p>aleissia@polilam.com</p><p>409.218.2447</p>",
   "colorOver": "#945751",
   "shortname": "LA"
  },
  "st20": {
   "link": "",
   "name": "Maine",
   "color": "#4c4339",
   "comment": "<h3><strong>Laurie Barton</strong></h3><p>Specifications Sales Rep</p><p>laurie@polilam.com</p><p>781.217.1471</p>",
   "colorOver": "#945751",
   "shortname": "ME"
  },
  "st21": {
   "link": "",
   "name": "Maryland",
   "color": "#4c4339",
   "comment": "<h3><strong>Joey Mortel</strong></h3><p>Specifications Sales Rep</p><p>joey@polilam.com</p><p>646.248.0611</p>",
   "colorOver": "#945751",
   "shortname": "MD"
  },
  "st22": {
   "link": "",
   "name": "Massachusetts",
   "color": "#4c4339",
   "comment": "<h3><strong>Laurie Barton</strong></h3><p>Specifications Sales Rep</p><p>laurie@polilam.com</p><p>781.217.1471</p>",
   "colorOver": "#945751",
   "shortname": "MA"
  },
  "st23": {
   "link": "",
   "name": "Michigan",
   "color": "#4c4339",
   "comment": "<h3><strong>Midwest Sales</strong></h3><p>midwest@polilam.com</p><p>409.218.2447</p>",
   "colorOver": "#945751",
   "shortname": "MI"
  },
  "st24": {
   "link": "",
   "name": "Minnesota",
   "color": "#4c4339",
   "comment": "<h3><strong>Krista Holen</strong></h3><p>Specifications Sales Rep</p><p>krista@polilam.com</p><p>952.426.5066</p>",
   "colorOver": "#945751",
   "shortname": "MN"
  },
  "st25": {
   "link": "",
   "name": "Mississippi",
   "color": "#4c4339",
   "comment": "<h3><strong>Aleissia Cano</strong></h3><p>Specifications Sales Rep</p><p>aleissia@polilam.com</p><p>409.218.2447</p>",
   "colorOver": "#945751",
   "shortname": "MS"
  },
  "st26": {
   "link": "",
   "name": "Missouri",
   "color": "#4c4339",
   "comment": "<h3><strong>Midwest Sales</strong></h3><p>midwest@polilam.com</p><p>409.218.2447</p>",
   "colorOver": "#945751",
   "shortname": "MO"
  },
  "st27": {
   "link": "",
   "name": "Montana",
   "color": "#4c4339",
   "comment": "<h3><strong>Aleissia Cano</strong></h3><p>Specifications Sales Rep</p><p>aleissia@polilam.com</p><p>409.218.2447</p>",
   "colorOver": "#945751",
   "shortname": "MT"
  },
  "st28": {
   "link": "",
   "name": "Nebraska",
   "color": "#4c4339",
   "comment": "<h3><strong>Aleissia Cano</strong></h3><p>Specifications Sales Rep</p><p>aleissia@polilam.com</p><p>409.218.2447</p>",
   "colorOver": "#945751",
   "shortname": "NE"
  },
  "st29": {
   "link": "",
   "name": "Nevada",
   "color": "#4c4339",
   "comment": "<h3><strong>Sandra Todd</strong></h3><p>Specifications Sales Rep</p><p>sandra@polilam.com</p><p>562.717.2722</p>",
   "colorOver": "#945751",
   "shortname": "NV"
  },
  "st30": {
   "link": "",
   "name": "New Hampshire",
   "color": "#4c4339",
   "comment": "<h3><strong>Laurie Barton</strong></h3><p>Specifications Sales Rep</p><p>laurie@polilam.com</p><p>781.217.1471</p>",
   "colorOver": "#945751",
   "shortname": "NH"
  },
  "st31": {
   "link": "",
   "name": "New Jersey",
   "color": "#4c4339",
   "comment": "<h3><strong>Joey Mortel</strong></h3><p>Specifications Sales Rep</p><p>joey@polilam.com</p><p>646.248.0611</p>",
   "colorOver": "#945751",
   "shortname": "NJ"
  },
  "st32": {
   "link": "",
   "name": "New Mexico",
   "color": "#4c4339",
   "comment": "<h3><strong>Aleissia Cano</strong></h3><p>Specifications Sales Rep</p><p>aleissia@polilam.com</p><p>409.218.2447</p>",
   "colorOver": "#945751",
   "shortname": "NM"
  },
  "st33": {
   "link": "",
   "name": "New York",
   "color": "#4c4339",
   "comment": "<h3><strong>Joey Mortel</strong></h3><p>Specifications Sales Rep</p><p>joey@polilam.com</p><p>646.248.0611</p>",
   "colorOver": "#945751",
   "shortname": "NY"
  },
  "st34": {
   "link": "",
   "name": "North Carolina",
   "color": "#4c4339",
   "comment": "<h3><strong>Aleissia Cano</strong></h3><p>Specifications Sales Rep</p><p>aleissia@polilam.com</p><p>409.218.2447</p>",
   "colorOver": "#945751",
   "shortname": "NC"
  },
  "st35": {
   "link": "",
   "name": "North Dakota",
   "color": "#4c4339",
   "comment": "<h3><strong>Krista Holen</strong></h3><p>Specifications Sales Rep</p><p>krista@polilam.com</p><p>952.426.5066</p>",
   "colorOver": "#945751",
   "shortname": "ND"
  },
  "st36": {
   "link": "",
   "name": "Ohio",
   "color": "#4c4339",
   "comment": "<h3><strong>Midwest Sales</strong></h3><p>midwest@polilam.com</p><p>409.218.2447</p>",
   "colorOver": "#945751",
   "shortname": "OH"
  },
  "st37": {
   "link": "",
   "name": "Oklahoma",
   "color": "#4c4339",
   "comment": "<h3><strong>Aleissia Cano</strong></h3><p>Specifications Sales Rep</p><p>aleissia@polilam.com</p><p>409.218.2447</p>",
   "colorOver": "#945751",
   "shortname": "OK"
  },
  "st38": {
   "link": "",
   "name": "Oregon",
   "color": "#4c4339",
   "comment": "<h3><strong>Sandra Todd</strong></h3><p>Specifications Sales Rep</p><p>sandra@polilam.com</p><p>562.717.2722</p>",
   "colorOver": "#945751",
   "shortname": "OR"
  },
  "st39": {
   "link": "",
   "name": "Pennsylvania",
   "color": "#4c4339",
   "comment": "<h3><strong>Joey Mortel</strong></h3><p>Specifications Sales Rep</p><p>joey@polilam.com</p><p>646.248.0611</p>",
   "colorOver": "#945751",
   "shortname": "PA"
  },
  "st40": {
   "link": "",
   "name": "Rhode Island",
   "color": "#4c4339",
   "comment": "<h3><strong>Laurie Barton</strong></h3><p>Specifications Sales Rep</p><p>laurie@polilam.com</p><p>781.217.1471</p>",
   "colorOver": "#945751",
   "shortname": "RI"
  },
  "st41": {
   "link": "",
   "name": "South Carolina",
   "color": "#4c4339",
   "comment": "<h3><strong>Aleissia Cano</strong></h3><p>Specifications Sales Rep</p><p>aleissia@polilam.com</p><p>409.218.2447</p>",
   "colorOver": "#945751",
   "shortname": "SC"
  },
  "st42": {
   "link": "",
   "name": "South Dakota",
   "color": "#4c4339",
   "comment": "<h3><strong>Krista Holen</strong></h3><p>Specifications Sales Rep</p><p>krista@polilam.com</p><p>952.426.5066</p>",
   "colorOver": "#945751",
   "shortname": "SD"
  },
  "st43": {
   "link": "",
   "name": "Tennessee",
   "color": "#4c4339",
   "comment": "<h3><strong>Aleissia Cano</strong></h3><p>Specifications Sales Rep</p><p>aleissia@polilam.com</p><p>409.218.2447</p>",
   "colorOver": "#945751",
   "shortname": "TN"
  },
  "st44": {
   "link": "",
   "name": "Texas",
   "color": "#4c4339",
   "comment": "<h2>North Texas</h2><h3><strong>Shawnda Brown</strong></h3><p>Specifications Sales Rep</p><p>shawnda@polilam.com</p><p>972.757.9695</p></br><h2>Central & South Texas</h2><h3><strong>Jeana Hur</strong></h3><p>Specifications Sales Rep</p><p>jeana@polilam.com</p><p>713.247.9226</p>",
   "colorOver": "#945751",
   "shortname": "TX"
  },
  "st45": {
   "link": "",
   "name": "Utah",
   "color": "#4c4339",
   "comment": "<h3><strong>Aleissia Cano</strong></h3><p>Specifications Sales Rep</p><p>aleissia@polilam.com</p><p>409.218.2447</p>",
   "colorOver": "#945751",
   "shortname": "UT"
  },
  "st46": {
   "link": "",
   "name": "Vermont",
   "color": "#4c4339",
   "comment": "<h3><strong>Laurie Barton</strong></h3><p>Specifications Sales Rep</p><p>laurie@polilam.com</p><p>781.217.1471</p>",
   "colorOver": "#945751",
   "shortname": "VT"
  },
  "st47": {
   "link": "",
   "name": "Virginia",
   "color": "#4c4339",
   "comment": "<h3><strong>Joey Mortel</strong></h3><p>Specifications Sales Rep</p><p>joey@polilam.com</p><p>646.248.0611</p>",
   "colorOver": "#945751",
   "shortname": "VA"
  },
  "st48": {
   "link": "",
   "name": "Washington",
   "color": "#4c4339",
   "comment": "<h3><strong>Sandra Todd</strong></h3><p>Specifications Sales Rep</p><p>sandra@polilam.com</p><p>562.717.2722</p>",
   "colorOver": "#945751",
   "shortname": "WA"
  },
  "st49": {
   "link": "",
   "name": "West Virginia",
   "color": "#4c4339",
   "comment": "<h3><strong>Joey Mortel</strong></h3><p>Specifications Sales Rep</p><p>joey@polilam.com</p><p>646.248.0611</p>",
   "colorOver": "#945751",
   "shortname": "WV"
  },
  "st50": {
   "link": "",
   "name": "Wisconsin",
   "color": "#4c4339",
   "comment": "<h3><strong>Krista Holen</strong></h3><p>Specifications Sales Rep</p><p>krista@polilam.com</p><p>952.426.5066</p>",
   "colorOver": "#945751",
   "shortname": "WI"
  },
  "st51": {
   "link": "",
   "name": "Wyoming",
   "color": "#4c4339",
   "comment": "<h3><strong>Aleissia Cano</strong></h3><p>Specifications Sales Rep</p><p>aleissia@polilam.com</p><p>409.218.2447</p>",
   "colorOver": "#945751",
   "shortname": "WY"
  }
 },
 "points": {}
};